import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './i18n';

import './index.css';
import App from './App';
import AuthProvider from './apis/auth/AuthProvider';
import GenericProvider from './apis/generic/GenericProvider';
import CargoProvider from './apis/cargo/CargoProvider';
import CargoReportProvider from './apis/cargo/CargoReportProvider';
import CargoSearchListProvider from './apis/cargoSearchList/CargoSearchListProvider';
import CargoDocumentTypeProvider from './apis/cargoDocumentType/CargoDocumentTypeProvider';
import UserProvider from './apis/user/UserProvider';
import ClientProvider from './apis/client/ClientProvider';
import ReleaseProvider from './apis/release/ReleaseProvider';
import ExportListProvider from './apis/exportList/exportListProvider';
import WarehouseClientProvider from './apis/warehouseClient/WarehouseClientProvider';
import WarehouseUserClientReportDailyProvider from './apis/warehouseUserClientReportDaily/WarehouseUserClientReportDailyProvider';
import RoleProvider from './apis/role/RoleProvider';
import DestinationProvider from './apis/destination/DestinationProvider';
import BranchProvider from './apis/branch/BranchProvider';
import SupplierProvider from './apis/supplier/SupplierProvider';
import WarehouseProvider from './apis/warehouse/WarehouseProvider';
import ShipInfoProvider from './apis/ShipInfo/ShipInfoProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <ClientProvider>
          <BranchProvider>
            <SupplierProvider>
              <GenericProvider>
                <CargoSearchListProvider>
                  <CargoDocumentTypeProvider>
                    <CargoProvider>
                      <CargoReportProvider>
                        <ShipInfoProvider> 
                          <DestinationProvider>
                            <ReleaseProvider>
                              <ExportListProvider>
                                <WarehouseProvider>
                                  <WarehouseClientProvider>
                                    <WarehouseUserClientReportDailyProvider>
                                      <RoleProvider>
                                        <App />
                                      </RoleProvider>
                                    </WarehouseUserClientReportDailyProvider>
                                  </WarehouseClientProvider>
                                </WarehouseProvider>
                              </ExportListProvider>
                            </ReleaseProvider>
                          </DestinationProvider>
                        </ShipInfoProvider> 
                      </CargoReportProvider>
                    </CargoProvider>
                  </CargoDocumentTypeProvider>
                </CargoSearchListProvider>
              </GenericProvider>
            </SupplierProvider>
          </BranchProvider>
        </ClientProvider>
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>
);
